import InvestigationCard from "./InvestigationCard";

export default InvestigationCard;
